const isDarkCode = (): boolean => __DARK_CODE__ === 'true';

export default isDarkCode;
